/**
 * The public demo logins shown on the landing page. These accounts are made (and their passwords put
 * back every night) by functions/src/demoSeed.ts; keep the two in step.
 */
export const DEMO_PASSWORD = 'MefDemo2026!';
const at = (key: string) => `${key}@demo.muyikaratu.com`;

export interface DemoLogin { role: 'Admin' | 'Teacher' | 'Student'; who: string; email: string }
export interface DemoInstitution { id: string; name: string; nameAr?: string; kind: string; blurb: string; accent: string; region: 'Nigeria' | 'Saudi Arabia'; logins: DemoLogin[] }

export const DEMO_INSTITUTIONS: DemoInstitution[] = [
    {
        id: 'demo-ecobalance', name: 'Ecobalance Academy', kind: 'Training centre', accent: '#16a34a', region: 'Nigeria',
        blurb: 'Six online HSE and safety courses with ESMI: certificate rules, practical sign-off, QR certificates, sponsors and fees.',
        logins: [
            { role: 'Admin', who: 'Centre manager', email: at('ecobalance.admin') },
            { role: 'Teacher', who: 'Instructor', email: at('ecobalance.instructor') },
            { role: 'Student', who: 'Learner', email: at('ecobalance.learner') },
        ],
    },
    {
        id: 'demo-university', name: 'MEF Demo University', kind: 'University', accent: '#2563eb', region: 'Nigeria',
        blurb: 'Faculties, course registration, credit units, CGPA on the scale the university chooses, HOD → Dean → Senate approval, transcripts.',
        logins: [
            { role: 'Admin', who: 'Registry / HOD / Dean', email: at('university.admin') },
            { role: 'Teacher', who: 'Lecturer', email: at('university.lecturer') },
            { role: 'Student', who: 'Student', email: at('university.student') },
        ],
    },
    {
        id: 'demo-alhuda', name: 'Al-Huda Islamiyya & Tahfiz', kind: 'Islamiyya & Tahfiz', accent: '#b45309', region: 'Nigeria',
        blurb: 'Halaqas, Juz progress, AI recitation checking, Islamiyya lessons and CBT, Musabaqa and fees.',
        logins: [
            { role: 'Admin', who: 'Proprietor', email: at('alhuda.admin') },
            { role: 'Teacher', who: 'Ustaz', email: at('alhuda.teacher') },
            { role: 'Student', who: 'Student', email: at('alhuda.student') },
        ],
    },
    {
        id: 'demo-saudi-university', name: 'Saudi Demo University (Riyadh)', nameAr: 'الجامعة السعودية التجريبية', kind: 'Saudi university', accent: '#0f766e', region: 'Saudi Arabia',
        blurb: 'Colleges and the preparatory year, levels 1–8, the Saudi 5-point GPA, registration, results approved HOD → Dean → Senate (council), transcripts. Hijri sessions, SAR.',
        logins: [
            { role: 'Admin', who: 'Admission & Registration', email: at('saudiuni.admin') },
            { role: 'Teacher', who: 'Faculty member', email: at('saudiuni.lecturer') },
            { role: 'Student', who: 'Student', email: at('saudiuni.student') },
        ],
    },
    {
        id: 'demo-ipa', name: 'Institute of Public Administration — Riyadh (Demo)', nameAr: 'معهد الإدارة العامة — الرياض (تجريبي)', kind: 'Institute', accent: '#1d4ed8', region: 'Saudi Arabia',
        blurb: 'Diplomas in Law, Secretarial Studies, Accounting and HR; the English Language Center (ELC) levels; short courses for government employees.',
        logins: [
            { role: 'Admin', who: 'Registrar', email: at('ipa.admin') },
            { role: 'Teacher', who: 'Faculty member', email: at('ipa.lecturer') },
            { role: 'Student', who: 'Diploma student', email: at('ipa.student') },
        ],
    },
    {
        id: 'demo-british', name: 'Riyadh British International School (Demo)', nameAr: 'مدرسة الرياض البريطانية العالمية (تجريبية)', kind: 'British curriculum', accent: '#7c3aed', region: 'Saudi Arabia',
        blurb: 'Key Stages 3–5, IGCSE and A Level with A*–G grades, plus the Arabic, Islamic Studies and Saudi Social Studies the Ministry requires.',
        logins: [
            { role: 'Admin', who: 'Principal', email: at('british.admin') },
            { role: 'Teacher', who: 'Teacher', email: at('british.teacher') },
            { role: 'Student', who: 'Year 10 student', email: at('british.student') },
        ],
    },
    {
        id: 'demo-american', name: 'Riyadh American International School (Demo)', nameAr: 'مدرسة الرياض الأمريكية العالمية (تجريبية)', kind: 'American curriculum', accent: '#be123c', region: 'Saudi Arabia',
        blurb: 'Middle and high school, Common Core subjects and AP, A–F letter grades, plus Arabic, Islamic Studies and Saudi Social Studies.',
        logins: [
            { role: 'Admin', who: 'Head of School', email: at('american.admin') },
            { role: 'Teacher', who: 'Teacher', email: at('american.teacher') },
            { role: 'Student', who: 'Grade 9 student', email: at('american.student') },
        ],
    },
];
